// Shared by ItemsExpiringSoon page and the dashboard's "Expiring Soon" card —
// keeps the expiry-window definition in one place instead of two copies.
export function getExpiringStockItems(items, monthsAhead = 2) {
    const cutoff = new Date();
    cutoff.setMonth(cutoff.getMonth() + monthsAhead);
    const today = new Date();

    const expiringStockItems = [];

    items.forEach((item) => {
        if (item.Stock && Array.isArray(item.Stock)) {
            item.Stock.forEach((stock) => {
                if (stock.quantityRemaining > 0 && stock.expiryDate) {
                    const expiryDate = new Date(stock.expiryDate);

                    if (expiryDate <= cutoff && expiryDate >= today) {
                        const daysUntilExpiry = Math.ceil(
                            (expiryDate - today) / (1000 * 60 * 60 * 24),
                        );

                        expiringStockItems.push({
                            id: `${item.id}-${stock.id}`,
                            itemId: item.id,
                            stockId: stock.id,
                            name: item.name,
                            barcode: item.barcode,
                            description: item.description,
                            quantityRemaining: stock.quantityRemaining,
                            quantityInitial: stock.quantityInitial,
                            pricePurchase: stock.pricePurchase,
                            expiryDate: stock.expiryDate,
                            daysUntilExpiry: daysUntilExpiry,
                            stockLocationName:
                                stock.stockLocation?.name || "N/A",
                            otherPartyName: stock.otherParty?.name || "N/A",
                            addedBy: stock.addedBy?.name || "N/A",
                        });
                    }
                }
            });
        }
    });

    expiringStockItems.sort((a, b) => a.daysUntilExpiry - b.daysUntilExpiry);
    return expiringStockItems;
}
